import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const IFRAME_RESULT = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    QUERY_FINISH: null,
    DOWNLOAD_REQUEST: null,
    DOWNLOAD_SUCCESS: null,
  },
  'IFRAME_RESULT'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data, count) {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: { orderToken: data.orderToken },
        errControl: true,
        hideProgress: true,
        endpoint: 'cashierii/order/v1/unauth/query-trade-result-iframe',
        requestAction: IFRAME_RESULT.INIT_REQUEST,
        successAction: IFRAME_RESULT.INIT_SUCCESS,
        success: function(result) {
          if (result.payResult === 'P' && count > 0) {
            setTimeout(() => {
              dispatch(init(data, --count))
            }, 2000)
          } else {
            dispatch({
              type: IFRAME_RESULT.QUERY_FINISH,
              payload: true,
            })
          }
        },
      })
    )
  }
}

export function downloadPDF(data, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cashierii/pay/v1/unauth/pay-result-file',
        requestAction: IFRAME_RESULT.DOWNLOAD_REQUEST,
        successAction: IFRAME_RESULT.DOWNLOAD_SUCCESS,
        success(result) {
          typeof callback === 'function' && callback(null, result)
        },
        error() {
          typeof callback === 'function' && callback(new Error('error'))
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers – same shape as PayPage Result so shared Result component works
// ------------------------------------
const ACTION_HANDLERS = {
  [IFRAME_RESULT.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [IFRAME_RESULT.INIT_SUCCESS]: (state, action) => {
    const p = action.payload || {}
    return Object.assign({}, state, {
      payResult: p.payResult,
      merchantReturnUrl: p.merchantReturnUrl,
      canTryAgain: p.canTryAgain,
      failMessage: p.failMessage,
      payResultInfo: p.lastPayerInfo || p.payResultInfo || {},
    })
  },
  [IFRAME_RESULT.QUERY_FINISH]: (state, action) =>
    Object.assign({}, state, { queryFinish: action.payload }),
  [IFRAME_RESULT.DOWNLOAD_REQUEST]: (state) => state,
  [IFRAME_RESULT.DOWNLOAD_SUCCESS]: (state) => state,
}

// ------------------------------------
// Reducer – key payPageResultState so Result component works without change
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'iframeResult',
    reducerMap: {
      payPageResultState: reducer,
    },
    middlewares: [apiMiddleware, routerMiddleware(history)],
    initialActions: [],
  }
}
